package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJan102022StrAIberryBaseArchDecisionPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/jan102022StrAIberryBaseArchDecision.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/jan102022-str-a-iberry-base-arch-decision")
@Composable
fun Jan102022StrAIberryBaseArchDecisionPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("jan-10-2022-straiberry-base-arch-decision") }) {
        org.jetbrains.compose.web.dom.Text("jan-10-2022-StrAIberry-Base-Arch-decision")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This week was focused on defining the foundational architecture of the strAIberry app, setting the stage for scalable and maintainable development. Initially, we considered a multimodule approach, where each feature (e.g., checkup, home, profile) would live in its own module, with shared logic in a ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("core")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("common")
        }
        org.jetbrains.compose.web.dom.Text(" module. This would promote modularity and team autonomy. However, after reviewing the current scope and user stories, still relatively small, we decided to start with a single app module to reduce overhead and accelerate development. The plan is to split into modules later if the project grows in complexity or team size. The core architecture follows Clean Architecture:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Domain: Contains business logic, use cases, and entities.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Data: Handles data class.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Presentation: Manages UI logic, view models, and user interactions. For the UI layer, we chose MVVM (Model-View-ViewModel) pattern:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("View (UI) binds to ViewModel via data binding.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("ViewModel exposes observable data.")
                }
            }
        }
    }
}
